"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
const moment = require('moment');
const { isSuper, isSupplierRoleWithOrderAccess } = require('../user');
const articleModel = require('../article');
const { calculateGrossWeightInKg } = require('../article');
const { orderStates, orderFlowTypes } = require('./order.const');
const { transportPriceList, transportPriceListIndexAdjusted20250701, } = require('./freightCosts');
const { getDisposableQuantity } = require('../article');
const { calculateTotalForRow, getUnitOnRow, } = require('../../interfaces/orderAndInvoiceRows/properties');
const { filterOutAlcTaxCancellingRows, getAlcTaxCancellingRows, totalAlcTax, } = require('../../interfaces/orderAndInvoiceRows/alcTaxAdjustments');
const { calculateTotalForOrder, getNumberOfOrderUnitsOnRows, getHandlingCostRows, filterOutHandlingCostRows, filterOutUtilityArticles, removeSpecialRows, } = require('../../interfaces/orderAndInvoiceRows/collections');
const { getNumberOfOrderUnitsOnRow, } = require('../../interfaces/orderAndInvoiceRows');
const { orderAlreadySentToWarehouseState } = require('./const.extras');
const EXACTA_FREIGHT_COST_PER_KG = 2.3;
const PALLET_COSTS = {
    EPAL: 85,
    EUR6: 75,
    QUARTER_PALLET: 55,
    SEAPAL: 120,
    OTHER: 0,
};
const getCustomer = order => order.supplierCustomer || order.customerSubUnit;
const isFreshxOrder = order => order.orderFlowType === orderFlowTypes.freshx;
const isStandardOrderOnNotCoPack = order => !!(order.owningSupplierOrganizationId &&
    order.orderFullfillmentCenter &&
    order.orderFullfillmentCenter.orderFlowType === 'standard' &&
    !order.orderFullfillmentCenter.isCopack);
const isCoPackOrder = order => !!(order.orderFullfillmentCenter && order.orderFullfillmentCenter.isCopack);
const getOrderSummary = order => {
    // TODO this looks strange - look into
    const isReturnToSupplierOrder = order.orderOrigin === 'returnToSupplier';
    const totalRecycle = _.sumBy(order.orderRows || [], x => x.totalRecycle);
    const totalExclVATnRecycle = isReturnToSupplierOrder
        ? calculateTotalForOrder(order.orderRows)
        : calculateTotalForOrder(removeSpecialRows(order.orderRows));
    return {
        totalRecycle,
        totalIncRecycle: totalRecycle + totalExclVATnRecycle,
        numberOfArticlesOnOrder: removeSpecialRows(order.orderRows).length,
        totalExclVATnRecycle,
    };
};
function getInvoiceRowsFromOrder(order) {
    const customer = getCustomer(order);
    if (!customer)
        throw new Error('Cannot make desicions on orders without endcustomers');
    return order.orderRows.map(or => ({ ...or }));
}
function hasCustomerAllowedToOrder(order) {
    const customer = getCustomer(order);
    if (!customer)
        throw new Error('Cannot make desicions on orders without endcustomers');
    return customer.approvedCustomer && !customer.blocked;
}
const hasCompleteCollies = order => {
    const { orderRows } = order;
    if (!orderRows)
        return false;
    return !!orderRows
        .filter(x => x.orderUnit === articleModel.orderUnits.package)
        .every(x => _.isInteger(x.orderedQuantity / _.get(x, 'article.colliSize', 1)));
};
function hasADeliveryDate(order) {
    return !!order.deliveryDate;
}
function hasNoRemarksOrIsDropshipping(order) {
    if (order.orderFlowType === 'email') {
        return true;
    }
    if (!order.remarks)
        return true;
    return order.remarks.trim() === '';
}
function isNotABackOrder(order) {
    return order.orderType !== 'Backorder';
}
function getNrOfCollies(order) {
    return getNumberOfOrderUnitsOnRows(removeSpecialRows(order.orderRows));
}
const VINDEN_HANDLING_COST_FIRST_PICK = 8.25;
const VINDEN_HANDLING_COST_NOT_FIRST_PICK = 5;
const VINDEN_MAX_HANDLING_COST_PER_ARTICLE = 103;
const STOCKFILLER_COST_PERCENTAGE = 0.02;
const EXACTA_DFP_PRICE = 12;
const EXACTA_KFP_PRICE = 10;
const EXACTA_RETURN_FREIGHT_COST = 0;
function getNumberOfPicks(order) {
    let nrOfKFPs = 0;
    let nrOfDFPs = 0;
    const orderRows = order.orderRows || [];
    for (let i = 0; i < orderRows.length; i++) {
        const row = orderRows[i];
        const absolutDeliveredQuantity = Math.abs(row.deliveredQuantity);
        const colliSize = _.get(row, 'article.colliSize', 1);
        nrOfDFPs += Math.floor(absolutDeliveredQuantity / colliSize);
        nrOfKFPs += absolutDeliveredQuantity % colliSize;
    }
    return { nrOfKFPs, nrOfDFPs };
}
// this is the new prices
function getHandlingCost(order) {
    if ((_.get(order, 'customerSubUnit.chain') || '').startsWith('Coop')) {
        return 0;
    }
    if (order.orderFlowType === 'email') {
        return 0;
    }
    if (order.cancelled) {
        return 0;
    }
    const actualArticleRows = filterOutUtilityArticles(removeSpecialRows(order.orderRows)).filter(x => !!x.article);
    if (order.orderOrigin === 'systembolaget') {
        const isReturn = _.sumBy(order.orderRows, or => or.orderedQuantity) < 0;
        if (isReturn)
            return 0;
        const picks = getNumberOfPicks(order);
        return (picks.nrOfKFPs * EXACTA_KFP_PRICE + picks.nrOfDFPs * EXACTA_DFP_PRICE);
    }
    let handlingCost = 0;
    for (let i = 0; i < (actualArticleRows || []).length; i++) {
        const row = actualArticleRows[i];
        const rowCollies = getNumberOfOrderUnitsOnRow(row);
        // max 103 per produkt
        // 8.25 första, 4 per kolli
        const rowCost = Math.min(VINDEN_MAX_HANDLING_COST_PER_ARTICLE, VINDEN_HANDLING_COST_FIRST_PICK +
            (rowCollies - 1) * VINDEN_HANDLING_COST_NOT_FIRST_PICK);
        if (row.deliveredQuantity !== 0) {
            handlingCost += rowCost;
        }
    }
    if (order.orderOrigin === 'stockfiller') {
        return _.round(handlingCost +
            STOCKFILLER_COST_PERCENTAGE * _.sumBy(order.orderRows, or => or.total), 2);
    }
    return handlingCost;
}
function getPalletSize(deliveryPalletType) {
    return (deliveryPalletType || 'EUR6').replace('SRS_', '');
}
function getPalletCost(order) {
    if (order.cancelled) {
        return 0;
    }
    if (_.sumBy(order.orderRows, 'deliveredQuantity') === 0) {
        return 0;
    }
    if (order.orderOrigin === 'systembolaget' ||
        order.orderFlowType === 'email') {
        return 0;
    }
    const deliveryPalletTypes = !_.isEmpty(order.deliveryPalletTypes)
        ? order.deliveryPalletTypes
        : [order.deliveryPalletType].filter(x => !!x);
    if (_.isEmpty(deliveryPalletTypes)) {
        return 0;
    }
    return _.sum(deliveryPalletTypes.map(type => PALLET_COSTS[getPalletSize(type)]));
}
function copyOrder(order) {
    const orderCopy = _.cloneDeep(order);
    const validOrderRows = removeSpecialRows(orderCopy.orderRows)
        .filter(x => x.article && x.article.active && x.deliveredQuantity > 0)
        .map(x => ({
        ...x,
        deliveredBatchNumber: null,
        orderedBatchNumber: null,
        id: _.uuid(),
    }));
    const newOrder = {
        id: _.uuid(),
        orderState: 'draft',
        remarks: '',
        deliveryName: orderCopy.deliveryName,
        deliveryAddress: orderCopy.deliveryAddress,
        deliveryAddress2: orderCopy.deliveryAddress2,
        deliveryCity: orderCopy.deliveryCity,
        deliveryZipCode: orderCopy.deliveryZipCode,
        deliveryCountry: orderCopy.deliveryCountry,
        yourReference: orderCopy.yourReference,
        ourReference: orderCopy.ourReference,
        phone: orderCopy.phone,
        deliveryInformation: orderCopy.deliveryInformation,
        email: orderCopy.email,
        orderRows: validOrderRows,
        customerSubUnit: orderCopy.customerSubUnit,
        supplierCustomer: orderCopy.supplierCustomer,
        orderFullfillmentCenter: orderCopy.orderFullfillmentCenter,
    };
    return newOrder;
}
function getFreightCost(order) {
    if (order.cancelled) {
        return 0;
    }
    if (_.sumBy(order.orderRows, 'deliveredQuantity') === 0) {
        return 0;
    }
    if (order.orderFlowType === 'email') {
        return 0;
    }
    if ((_.get(order, 'customerSubUnit.chain') || '').startsWith('Coop')) {
        return 0;
    }
    if (order.needSpecialHandling) {
        return 0;
    }
    if (order.orderOrigin === 'systembolaget') {
        const isReturn = _.sumBy(order.orderRows, or => or.orderedQuantity) < 0;
        const freightCost = _.sumBy(order.orderRows, or => {
            const articleWeight = calculateGrossWeightInKg(or.article);
            if (!articleWeight) {
                return 0;
            }
            return articleWeight * or.deliveredQuantity * EXACTA_FREIGHT_COST_PER_KG;
        });
        if (isReturn)
            return EXACTA_RETURN_FREIGHT_COST;
        return freightCost;
    }
    // Vinden case
    if (!order.deliveryZipCode) {
        return 450;
    }
    const orderZipStart = _.parseInt(order.deliveryZipCode.substr(0, 2));
    const deliveryPalletTypes = _.get(order, 'deliveryPalletTypes', []);
    if (_.isEmpty(deliveryPalletTypes)) {
        deliveryPalletTypes.push(order.deliveryPalletType);
    }
    return _.sumBy(deliveryPalletTypes, deliveryPalletType => {
        const palletType = getPalletSize(deliveryPalletType);
        const transportPriceListToUse = new Date(order.orderDate) >= new Date('2025-07-01')
            ? transportPriceListIndexAdjusted20250701
            : transportPriceList;
        const transportPriceEntry = transportPriceListToUse.find(p => p.type === palletType &&
            orderZipStart >= p.zipStart &&
            orderZipStart <= p.zipEnd);
        if (transportPriceEntry) {
            return transportPriceEntry.price;
        }
        return 450;
    });
}
function hasValidPermitsForPurchase(order) {
    const customer = getCustomer(order);
    if (customer.hasAlcoholPermit) {
        return true;
    }
    const orderRowsWithoutPant = removeSpecialRows(order.orderRows);
    let orderOk = true;
    for (let i = 0; i < orderRowsWithoutPant.length; i++) {
        const row = orderRowsWithoutPant[i];
        const { article } = row;
        if (article !== null) {
            orderOk =
                orderOk &&
                    article.alcoholPercentage <= 3.5 &&
                    !article.requiresAlcoholPermit;
        }
    }
    return orderOk;
}
function hasArticleOnOrderRowInStock(row, orderState, stockInfo) {
    const { article, orderedQuantity } = row;
    if (article) {
        if (article.isAlwaysOrderable) {
            return true;
        }
        if (!stockInfo) {
            return false;
        }
        if (stockInfo.isAlwaysOrderable) {
            return true;
        }
        return orderedQuantity <= getDisposableQuantity(stockInfo, orderState);
    }
    return true;
}
function hasAllArticlesOnOrderInStock(order, stockInfoOnOfcReport) {
    const usingStockInfoOnOfcMode = stockInfoOnOfcReport !== undefined;
    if (usingStockInfoOnOfcMode && stockInfoOnOfcReport.rows.length === 0) {
        return false;
    }
    const orderRowsWithoutPant = filterOutUtilityArticles(removeSpecialRows(order.orderRows));
    if (usingStockInfoOnOfcMode) {
        for (const row of orderRowsWithoutPant) {
            const article = row.article;
            if (article !== null) {
                const stockInfo = stockInfoOnOfcReport.rows.find(x => x.article.id === article.id);
                if (!stockInfo) {
                    return false;
                }
                if (!hasArticleOnOrderRowInStock(row, order.orderState, stockInfo)) {
                    return false;
                }
            }
        }
        return true;
    }
    if (order.orderFlowType === 'email') {
        return true;
    }
    // legacy mode
    for (const row of orderRowsWithoutPant) {
        if (row.article !== null) {
            if (!hasArticleOnOrderRowInStock(row, order.orderState)) {
                return false;
            }
        }
    }
    return true;
}
function hasOldArticles(order) {
    const orderRowsWithoutPant = filterOutUtilityArticles(removeSpecialRows(order.orderRows));
    let orderHasOldArticles = false;
    for (let i = 0; i < orderRowsWithoutPant.length; i++) {
        const row = orderRowsWithoutPant[i];
        const { article } = row;
        if (article !== null) {
            orderHasOldArticles =
                orderHasOldArticles ||
                    article.hasBatchWithExpiredDate === true ||
                    article.active === false;
        }
    }
    return orderHasOldArticles;
}
function isMissingSupplierCustomer(order) {
    if (!order.supplierCustomer && order.requiresSupplierCustomer)
        return true;
    return false;
}
const numberOfSuppliers = order => {
    const { orderRows } = order;
    if (_.isEmpty(orderRows))
        return 0;
    const rowsWithoutSpecialArticles = removeSpecialRows(orderRows);
    const supplierList = rowsWithoutSpecialArticles
        .map(row => _.get(row, 'article.supplierId'))
        .filter(x => x);
    return _.uniq(supplierList).length;
};
const qualifiesAsReturnToSupplierOrder = order => {
    if (_.get(order, 'customerSubUnit.customerType') !== 'supplier') {
        return false;
    }
    const nonSpecialRowsWithArticles = removeSpecialRows(order.orderRows).filter(x => x.article);
    if (nonSpecialRowsWithArticles.length === 0) {
        return false;
    }
    const onlyHasCommissionArticle = _.every(nonSpecialRowsWithArticles, x => x.article.onCopack);
    if (!onlyHasCommissionArticle) {
        return false;
    }
    const endCustomerSupplier = _.get(order, 'customerSubUnit.supplier.id') ||
        _.get(order, 'customerSubUnit.supplierId');
    return _.every(nonSpecialRowsWithArticles, row => (_.get(row, 'article.supplier.id') ||
        _.get(row, 'article.supplierId')) === endCustomerSupplier);
};
const applyPricedArticleToOrderRow = (orderRow, pricedArticle) => {
    /* eslint-disable no-param-reassign */
    orderRow.discount = pricedArticle.discount;
    orderRow.price = orderRow.discount
        ? pricedArticle.priceWithoutDiscount
        : pricedArticle.salesPrice;
    orderRow.priceList = pricedArticle.priceList;
    orderRow.total = calculateTotalForRow(orderRow);
    orderRow.article = pricedArticle;
    orderRow.name = pricedArticle.name;
    orderRow.unit = getUnitOnRow(orderRow);
    /* eslint-enable no-param-reassign */
    return orderRow;
};
function getDisplayQuantityWithUnit(row, prop, usesPackageCountInTheirSystem) {
    if (!_.includes(['orderedQuantity', 'deliveredQuantity'], prop)) {
        throw ('not supported prop', prop);
    }
    const { article } = row;
    if (!article)
        return '';
    if (article.orderUnit === 'single') {
        return `${row[prop]} st`;
    }
    if (article.orderUnit === 'package') {
        const colliSize = _.get(article, 'colliSize', 1);
        return usesPackageCountInTheirSystem
            ? `${row[prop]} frp`
            : `${row[prop] / colliSize} x ${colliSize}`;
    }
    if (article.orderUnit === 'weight') {
        return `${row[prop]} kg`;
    }
    // backup
    if (!article.orderUnit) {
        const colliSize = _.get(article, 'colliSize', 1);
        if (colliSize > 1) {
            return `${row[prop] / colliSize} x ${colliSize}`;
        }
    }
    return `${row[prop]} st`;
}
function getDisplayUnit(orderRow) {
    const { article } = orderRow;
    if (!article)
        return '';
    if (article.orderUnit === 'weight') {
        return 'kg';
    }
    return 'st';
}
function transformToUseSuppliersPackageCount(order) {
    const result = { ...order };
    const orderRows = (order.orderRows || []).map(row => {
        const article = _.get(row, 'article');
        if (article && article.orderUnit === 'package') {
            const colliSize = _.get(article, 'colliSize', 1);
            const deliveredQuantity = row.deliveredQuantity / colliSize;
            const orderedQuantity = row.orderedQuantity / colliSize;
            const price = row.price * colliSize;
            return {
                ...row,
                deliveredQuantity,
                orderedQuantity,
                price,
            };
        }
        return { ...row };
    });
    return {
        ...result,
        orderRows,
    };
}
function getOrderAlreadySentToWarehouse(order) {
    return _.includes(orderAlreadySentToWarehouseState, order.orderState);
}
const getDisplayName = order => {
    let displayName = _.get(order, 'customerSubUnit.name');
    if (order.supplierCustomer) {
        displayName = order.supplierCustomer.name;
    }
    return displayName || 'Kund saknas!';
};
// todo: use an options object. No more boolean flags!
function getViewModel(order, usesPackageCountInTheirSystem) {
    let result = { ...order };
    if (usesPackageCountInTheirSystem)
        result = transformToUseSuppliersPackageCount(result);
    const orderRows = (result.orderRows || []).map(x => {
        const displayOrderedQuantity = getDisplayQuantityWithUnit(x, 'orderedQuantity', usesPackageCountInTheirSystem);
        const displayDeliveredQuantity = getDisplayQuantityWithUnit(x, 'deliveredQuantity', usesPackageCountInTheirSystem);
        const displayArticleNumber = isStandardOrderOnNotCoPack(order)
            ? _.get(x, 'article.articleNumber')
            : _.get(x, 'article.supplierArticleNumber', _.get(x, 'article.articleNumber'));
        const displayUnit = getDisplayUnit(x);
        return {
            ...x,
            displayOrderedQuantity,
            displayDeliveredQuantity,
            displayArticleNumber,
            displayUnit,
        };
    });
    return {
        ...result,
        displayDeliveryDate: moment(order.deliveryDate).format('YYYY-MM-DD'),
        displayName: getDisplayName(order),
        displayOrderNumber: order.supplierOrderNumber || order.orderNumber,
        orderRows,
    };
}
const getUpdatedSupplierCommentForDeliveryDate = (order, supplierComment, deliveryDate) => {
    let resultSupplierComment = supplierComment || '';
    if (deliveryDate) {
        // Remove previous delivery date updates
        const regEx = /Uppskattat leveransdatum är [0-9-]+\./g;
        resultSupplierComment = resultSupplierComment.replace(regEx, '').trim();
        // Prepend delivery date update
        const newDeliveryDateString = moment(deliveryDate).format('YYYY-MM-DD');
        resultSupplierComment =
            `Uppskattat leveransdatum är ${newDeliveryDateString}. ${resultSupplierComment}`.trim();
    }
    return resultSupplierComment;
};
const isExportOrder = order => {
    const customer = getCustomer(order);
    if (!customer)
        return false;
    return (customer.deliveryCountry && !_.includes(customer.deliveryCountry, 'SE'));
};
const isStuckInCreatedState = order => order.orderState === 'created' &&
    isStandardOrderOnNotCoPack(order) &&
    moment().isAfter(moment(order.updatedAt).add(2, 'minutes'));
const requiresGroupInvoice = order => {
    // Return false for dropship orders (email flow)
    if (order.orderFlowType === 'email') {
        return false;
    }
    // For co-pack orders, use customerSubUnit
    if (isCoPackOrder(order)) {
        return order.customerSubUnit.requiresGroupInvoice;
    }
    // Otherwise, only check supplierCustomer
    return order.supplierCustomer?.requiresGroupInvoice || false;
};
const containsActiveArticles = order => _.some(order.orderRows, or => _.get(or, 'article.active', false));
const canCancel = order => order.orderState !== orderStates.invoiced &&
    order.orderState !== orderStates.delivered &&
    order.orderState !== orderStates.returned;
const canChangeDeliveryDate = order => !order.cancelled && canCancel(order);
const isUserAllowedToCancelOrder = (order, sessionUser) => {
    if (!isSuper(sessionUser) && !isSupplierRoleWithOrderAccess(sessionUser)) {
        return false;
    }
    if (isCoPackOrder(order)) {
        if (_.includes([orderStates.draft, orderStates.created, orderStates.received], order.orderState)) {
            return true;
        }
        return isSuper(sessionUser) && canCancel(order);
    }
    return canCancel(order);
};
const isUserAllowedToChangeDeliveryDate = (order, sessionUser) => {
    if (!isSuper(sessionUser) && !isSupplierRoleWithOrderAccess(sessionUser)) {
        return false;
    }
    if (isCoPackOrder(order)) {
        return isSuper(sessionUser) && canChangeDeliveryDate(order);
    }
    return canChangeDeliveryDate(order);
};
const isUserAllowedToDeliverOrder = (order, sessionUser) => {
    if (order.orderState !== orderStates.enRoute &&
        order.orderState !== orderStates.approvedByDropshipSupplier) {
        return false;
    }
    if (isCoPackOrder(order)) {
        return isSuper(sessionUser);
    }
    if (isFreshxOrder(order)) {
        return isSuper(sessionUser);
    }
    if (isSuper(sessionUser) || isSupplierRoleWithOrderAccess(sessionUser)) {
        return true;
    }
    return false;
};
module.exports = {
    hasCompleteCollies,
    hasCustomerAllowedToOrder,
    hasADeliveryDate,
    hasNoRemarksOrIsDropshipping,
    isNotABackOrder,
    hasValidPermitsForPurchase,
    hasAllArticlesOnOrderInStock,
    hasArticleOnOrderRowInStock,
    getNrOfCollies,
    getHandlingCost,
    getFreightCost,
    getPalletCost,
    getOrderSummary,
    hasOldArticles,
    numberOfSuppliers,
    filterOutAlcTaxCancellingRows,
    getAlcTaxCancellingRows,
    filterOutHandlingCostRows,
    getHandlingCostRows,
    qualifiesAsReturnToSupplierOrder,
    applyPricedArticleToOrderRow,
    totalAlcTax,
    copyOrder,
    getInvoiceRowsFromOrder,
    getNumberOfPicks,
    getViewModel,
    getOrderAlreadySentToWarehouse,
    getUpdatedSupplierCommentForDeliveryDate,
    isExportOrder,
    getCustomer,
    isStandardOrderOnNotCoPack,
    isCoPackOrder,
    isStuckInCreatedState,
    isMissingSupplierCustomer,
    requiresGroupInvoice,
    containsActiveArticles,
    isUserAllowedToChangeDeliveryDate,
    isUserAllowedToCancelOrder,
    isUserAllowedToDeliverOrder,
    PALLET_COSTS,
};
